import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from './Loading';
import Layout from './Layout';
import SEO from './SEO';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <SEO noindex={true} />
      <Layout>{children}</Layout>
    </>
  );
};

export default PrivateRoute;
